const { h, render, Component } = require('preact');

class TravelerInfo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.orderDetails.travelBookingInfo && this.props.orderDetails.travelBookingInfo.reservation && this.props.orderDetails.travelBookingInfo.reservation.travellerFirstName && this.props.orderDetails.travelBookingInfo.reservation.travellerLastName){
      return (
        <table class="remaining-tables">
          <tr>
            <td>{I18n.translate("js.modules.web_2018.traveler_info")}</td>
            <td>{this.props.orderDetails.travelBookingInfo.reservation.travellerFirstName}&nbsp;{this.props.orderDetails.travelBookingInfo.reservation.travellerLastName}</td>
          </tr>
        </table>
      );
    }
    else{
      return null;
    }
  }
}
module.exports = TravelerInfo
